import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import { PageHeader } from 'components/page-header'
import AvailabilityTab from './availability-tab'
import { makeStyles } from '@material-ui/styles'
import { usePortal } from 'lib/portal'

export const useStyles = makeStyles(theme => ({
  customRoot: {
    margin: 0,
    padding: '28px 36px 48px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 8px 96px',
    },
  },
}))

const AvailabilityPage = () => {
  const classes = useStyles()
  const { path } = useRouteMatch()
  const [HeaderActionsPortal, headerActionsTarget] = usePortal()

  const crumbs = [
    {
      label: 'Settings',
      to: path
        .split('/')
        .slice(0, 3)
        .join('/'),
    },
  ]

  return (
    <>
      <PageHeader
        title="Availability Settings"
        crumbs={crumbs}
        actions={headerActionsTarget}
      />
      <Box className={classes.customRoot}>
        <AvailabilityTab HeaderActionsPortal={HeaderActionsPortal} />
      </Box>
    </>
  )
}

export default AvailabilityPage
